import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${pxToRem(8)} 0;
`;

const DrawerIconWrapper = styled.div`
  margin-bottom: ${pxToRem(16)};
`;

const DrawerDescription = styled.p`
  font-size: 14;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  text-align: center;
  line-height: 1.5;
`;

const DrawerFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};

  > button {
    width: 100%;
  }
`;

const NonUsSellFromHomeDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <Button variant="primaryOutlined" textTransform="none" onClick={onClose}>
        {t('common.close')}
      </Button>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <DrawerContent>
        <DrawerIconWrapper>
          <InfoIcon width={35} height={35} />
        </DrawerIconWrapper>
        <DrawerDescription>
          {t('portfolio.sellFromHome.nonUs.title')}
          <br />
          <a href={`tel:${t('portfolio.sellFromHome.nonUs.phoneNumber')}`}>
            {t('portfolio.sellFromHome.nonUs.needHelp')}{' '}
            {t('portfolio.sellFromHome.nonUs.phone')}
          </a>
        </DrawerDescription>
      </DrawerContent>
    </BottomDrawer>
  );
};

NonUsSellFromHomeDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default NonUsSellFromHomeDrawer;
